export const SET_USER_TO_VERIFY = 'SET_USER_TO_VERIFY';
export const SET_VERIFICATION_SUCCESS = 'SET_VERIFICATION_SUCCESS';